import React from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";

const borderColor = "#C12B2D";
const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    borderBottomColor: "#C12B2D",
    backgroundColor: "#C12B2D",
    borderBottomWidth: 1,
    alignItems: "center",
    height: 24,
    textAlign: "center",
    fontStyle: "bold",
    flexGrow: 1,
  },
  name: {
    width: "30%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    color: "white",
  },
  description: {
    width: "50%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    color: "white",
  },
  // qty: {
  //   width: "20%",
  //   borderRightColor: borderColor,
  //   borderRightWidth: 1,
  // },
  rate: {
    width: "20%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    color: "white",
  },
  //   amount: {
  //     width: "15%",
  //   },
});

const InvoiceTableHeader = () => (
  <View style={styles.container}>
    <Text style={styles.name}>Items</Text>
    <Text style={styles.description}>Description</Text>
    <Text style={styles.rate}>Total</Text>
    {/* <Text style={styles.rate}>@</Text>
        <Text style={styles.amount}>Amount</Text> */}
  </View>
);

export default InvoiceTableHeader;
